import { gql } from '@apollo/client';
export const invitesQuery = gql `
  query userInvites($orderBy: [OrderByUserInviteInput2!], $search: String) {
    userInvites: userInvites2(
      where: { acceptedByUserId: { isNull: true }, email: { ilike: $search } }
      orderBy: $orderBy
    ) {
      id
      email
      expired
      role
      createdAt
      canManageMemeber: canManageMember
    }
  }
`;
